import { css } from 'styled-components';

export const box = css`
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.05);
`;

export const container = css`
  margin: 0 auto;
  max-width: 1170px;
  padding: 0px 15px;
`;

export const fontStyle = (color, fontSize, fontWeight) => `
  font-family: 'Open Sans', serif;
  ${color && `color: ${color};`}
  ${fontSize && `font-size: ${fontSize};`}
  ${fontWeight && `font-weight: ${fontWeight};`}
`;



// WEBPACK FOOTER //
// ./src/style/mixins.js